import { apiClient } from "lib/axios";

/**
 * Membership APIs are company-scoped by backend context.
 *
 * Rules:
 * - Do NOT send companyId.
 * - Do NOT expose OWNER assignment in frontend.
 */

export const getMemberships = async (params = {}) => {
  const { data } = await apiClient.get("/memberships", { params });
  return data;
};

export const updateMembership = async (id, body) => {
  const { companyId, ...cleanBody } = body || {};
  const { data } = await apiClient.put(`/memberships/${id}`, cleanBody);
  return data;
};

export const removeMembership = async (id) => {
  const { data } = await apiClient.delete(`/memberships/${id}`);
  return data;
};
